import { render, staticRenderFns } from "./SizeRecommendationSizeFeedbackFilters.vue?vue&type=template&id=47121a42&scoped=true"
import script from "./SizeRecommendationSizeFeedbackFilters.vue?vue&type=script&lang=js"
export * from "./SizeRecommendationSizeFeedbackFilters.vue?vue&type=script&lang=js"
import style0 from "./SizeRecommendationSizeFeedbackFilters.vue?vue&type=style&index=0&id=47121a42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47121a42",
  null
  
)

/* custom blocks */
import block0 from "./SizeRecommendationSizeFeedbackFilters.vue?vue&type=custom&index=0&blockType=i18n&locale=ko"
if (typeof block0 === 'function') block0(component)

export default component.exports